/**
 * RTK Query slice for the OneSignal opaque identity. Returns
 * `{ userId }` for `OneSignal.login(userId)`.
 */

import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchOneSignalIdentity } from '../util/api';
import * as log from '../util/log';

export type OneSignalIdentity = {
  userId: string;
  authHash: string;
};

const SLICE_NAME = 'oneSignalApi';

export const oneSignalApi = createApi({
  reducerPath: SLICE_NAME,
  baseQuery: () => ({ data: null }),
  tagTypes: ['OneSignalIdentity'],
  keepUnusedDataFor: 3600,
  endpoints: build => ({
    fetchOneSignalIdentity: build.query<OneSignalIdentity, void>({
      providesTags: ['OneSignalIdentity'],
      async queryFn() {
        try {
          const data = (await fetchOneSignalIdentity()) as OneSignalIdentity;
          return { data };
        } catch (e) {
          log.error(
            e instanceof Error ? e : new Error(String(e)),
            'onesignal.identity.fetch_failed',
            {}
          );
          return {
            error: {
              status: (e as { status?: number })?.status || 500,
              data: { code: 'ONESIGNAL_IDENTITY_FAILED' },
            },
          };
        }
      },
    }),
  }),
});

export const { useFetchOneSignalIdentityQuery } = oneSignalApi;
export default oneSignalApi.reducer;
